import { Injectable } from '@angular/core';

import { BehaviorSubject, Observable } from 'rxjs';

import { CreditPack } from '@models/credits-pack/credit-pack';
import { CreditPackBuy } from '@models/buy/credit/credit-pack-buy';
import { EndpointParams } from '@models/utils/endpoint-params';
import { HttpService } from 'src/app/services/http.service';
import { PaymentCreateResponse } from '@models/buy/response/payment-create-response';
import { Tax } from '@models/tax/tax';

@Injectable({
    providedIn: 'root'
})
export class CreditPackService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'payments', version: 1 };

    private creditPacksSubject = new BehaviorSubject<CreditPack[]>([]);
    private infoSubject = new BehaviorSubject<CreditPack>(new CreditPack());
    private isLoadingDataSubject = new BehaviorSubject<boolean>(true);
    private dataStore: { creditPacks: CreditPack[] } = { creditPacks: [] };

    readonly info = this.infoSubject.asObservable();
    readonly creditPacks = this.creditPacksSubject.asObservable();
    readonly isLoadingData = this.isLoadingDataSubject.asObservable();

    buy(creditPackBuy: CreditPackBuy): Observable<PaymentCreateResponse> {
        return new Observable<any>(observable => {
            this.post('creditpack/member', this.defaultEndpointParams, creditPackBuy).subscribe(
                data => observable.next(data),
                () => observable.next(false)
            );
        });
    }

    buyManual(creditPackBuyManual: CreditPackBuy): Observable<any> {
        return this.post('creditpack/member/manual', this.defaultEndpointParams, creditPackBuyManual);
    }

    list(tax: Tax): void {
        this.loading(true);
        this.listCreditsPack(tax).subscribe(
            () => {
                this.next([ ...this.dataStore.creditPacks ]);
                this.loading(false);
            }
        );
    }

    search(idCreditPack: string): void {
        this.get(`creditpack/member/${idCreditPack}`, this.defaultEndpointParams).subscribe(
            data => {
                const index: number = this.dataStore.creditPacks.findIndex(c => c.id === idCreditPack);
                if (index > -1) {
                    this.dataStore.creditPacks[index] = new CreditPack().build(data);
                } else {
                    this.dataStore.creditPacks.push(new CreditPack().build(data));
                }

                this.next([ ...this.dataStore.creditPacks ]);
            }
        );
    }

    private listCreditsPack(tax: Tax): Observable<boolean> {
        return new Observable<boolean>(observable => {
            this.get('creditpack/member', this.defaultEndpointParams).subscribe(
                data => {
                    this.dataStore.creditPacks = [];
                    data.forEach((creditPack: any) => {
                        this.dataStore.creditPacks.push(new CreditPack().buildWithTax(creditPack, tax));
                    });

                    observable.next(true);
                }, () => observable.next(false)
            );
        });
    }

    private next(data: CreditPack[]): void {
        this.creditPacksSubject.next(data);
    }

    private loading(value: boolean): void {
        this.isLoadingDataSubject.next(value);
    }
}
